<template>
    <div class="brochures-item">
        <div class="brochures-item__div-wrap">
            <div class="brochures-item__inner">
                <div class="brochures-item__image-wrap">
                    <ResponsiveImage v-if="brochureItem.ImageHtml.Src || brochureItem.ImageHtml.HasCrop" :imageModel="brochureItem.ImageHtml" wrapClass="brochures-item__image" />
                </div>
                <div class="brochures-item__text">
                    <h3 class="brochures-item__headline">{{ brochureItem.Headline }}</h3>
                    <div class="brochures-item__form custom-select__form" v-if="brochureItem.HasBrochureFiles">
                        <div class="brochures-item__form-col">
                            <div class="custom-select">
                                <span class="custom-select__current">
                                    <span class="custom-select__icon"
                                        :style="{ 'background-image': 'url(' + brochureItem.ActiveBrochureIconUrl + ')' }"></span>
                                    <span class="custom-select__label">{{ brochureItem.ActiveBrochureLabel }}</span>
                                </span>
                                <ul class="custom-select__list">
                                    <li :data-url="file.FileUrl" :data-label="file.LanguageLabel"
                                        :data-icon="file.LanguageIconUrl" class="custom-select__list-item"
                                        v-for="(file, index) in brochureItem.BrochureFiles"
                                        v-if="file.HasFile && file.HasLanguage">
                                        <span class="custom-select__icon"
                                            :style="{ 'background-image': 'url(' + file.LanguageIconUrl + ')' }"></span>
                                        <span class="custom-select__label">{{ file.LanguageLabel }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="brochures-item__form-col">
                            <a :href="brochureItem.ActiveBrochureUrl"
                                class="brochures-item__form-button custom-select__button"
                                target="_blank">{{ dictionaries.BrochureDownloadLabel }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponsiveImage from "./responsiveImage.vue";

export default {
    name: "brochureItem",
    components: {
        ResponsiveImage
    },
    props: ["brochureItem", "dictionaries"]
};
</script>